<template>
  <div class="boxbgcolor ioRecord" v-loading="loading">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="bdate">开始时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM"
              v-model="search.beginDate"
              type="month"
            >
            </el-date-picker>
          </div>
          <div class="form-group">
            <label for="bdate">结束时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM"
              v-model="search.endDate"
              type="month"
            >
            </el-date-picker>
          </div>

          <div class="form-group others">
            <span class="search_btn"
              ><button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :disabled="loading"
              >
                <i v-if="loading" class="el-icon-loading"></i>
                {{ loading ? "查询中..." : "查询" }}
              </button></span
            >

            <span class="download_btn"
              ><button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
                :disabled="exportLoading"
              >
                <i v-if="exportLoading" class="el-icon-loading"></i>
                {{ exportLoading ? "导出中..." : "导出" }}
              </button></span
            >

            <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
            <!-- <span class='switchGroup'>
								<el-select v-model="switchValue" placeholder="请选择展示方式">
									<el-option value='list' label='列表'>
										<span class='switch'><img src="@/assets/images/liebiao.png" width='16px'/><span class='switch-info'>列表</span></span>
									</el-option>
									<el-option value='chart' label='图表'>
										<span class='switch'><img src="@/assets/images/tubiao.png" width='16px'/><span class='switch-info'>图表</span></span>
									</el-option>
  								</el-select>
						</span> -->
          </div>
        </form>
      </div>
      <template>
        <div
          v-show="showChart"
          id="myChart"
          style="width: 100%; height: 500px"
        ></div>
        <div v-show="showList" class="show-list list-right">
          <el-table
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <!-- <el-table-column  show-overflow-tooltip
						label="车场名称"
						prop="">

						</el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              label="统计时间"
              prop="chargeDate"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="应收金额"
              prop="receivable"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="实收金额"
              prop="real_money"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="差异金额"
              prop="difference"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="临停缴费"
              prop="TEMPORARY"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="固定车收费"
              prop="fixed"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="线上缴费"
              prop="onlineMoney"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="现金缴费"
              prop="cashMoney"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="消费打折"
              prop="discount_money"
            >
            </el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="追缴道路欠费"
              prop="recoveryRealMoney"
            >
              <template slot-scope="scope">
                <span
                  class="link-trade-id"
                  @click="openRecovery(scope.row)"
                >{{ scope.row.recoveryRealMoney }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { getOnsiteParkingMonthReportList, chargeOfDay } from "@/api/url";
import dayjs from "dayjs";

import AreaTree from "../../commons/parking/commons/areaTree.vue";
import Page from "../../commons/parking/commons/page.vue";

// import Refresh from '../commons/refresh.vue';

export default {
  data() {
    return {
      loading: false,
      exportLoading: false,
      treeData: {
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        beginDate: "",
        endDate: "",
      },
      tableListData: [],
      myChart: {
        // 	 title : {
        // 		text: '每天收费统计',
        // 		subtext: '近一个月',
        // 		x: 'center',
        // align: 'right'

        // 	},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        // legend: {
        // 	data:['支付宝','微信','现金','建行无感','余额支付','总和'],
        // 	x: 'left'
        // },

        xAxis: [
          {
            name: "时间",
            splitLine: { show: true },
            axisLabel: {
              interval: 0,
              rotate: 40,
              color: "#333333",
            },
            axisLine: {
              lineStyle: { color: "#4488BB", width: 2 },
            },
            splitLine: { show: true },
            type: "category",
            data: [], //时间
          },
        ],
        yAxis: [{}, {}],
        series: [
          {
            name: "总和",
            type: "line",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#5dacff",
                    fontSize: 12,
                  },
                },
              },
            },
            smooth: true,
          },
        ],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    withExportLoading(task) {
      if (this.exportLoading) return;
      this.exportLoading = true;
      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        this.exportLoading = false;
      };
      const timer = setTimeout(release, 1500);
      try {
        const request = task();
        if (request && typeof request.finally === "function") {
          return request.finally(() => {
            clearTimeout(timer);
            release();
          });
        }
        return request;
      } catch (error) {
        clearTimeout(timer);
        release();
        throw error;
      }
    },
    downloadData() {
      if (!this.treeData.parkingId) {
        this.$message({ type: "warning", message: "请选择车场！" });
        return;
      }
      return this.withExportLoading(() =>
        this.$downloadFileRequest(
          "/api/onsite/onsiteOrders/monthlyStatementExport",
          {
            parkingId: this.treeData.parkingId,
            beginTime: this.search.beginDate,
            endTime: this.search.endDate,
          },
          "车场月报"
        )
      );
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.showList = true;
      this.showChart = false;
      this.search.beginDate = "";
      this.search.endDate = "";

      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.parkingId = "";
        this.tableListData = [];
        //  this.$message({
        // 	message: '请选择车场！',
        // 	type: 'warning'
        // 	});
      }
    },
    tableList: function (curPage) {
      var _this = this;
      this.loading = true;
      this.$get(getOnsiteParkingMonthReportList(), {
        page: curPage,
        limit: this.search.pageSize,
        parkingId: this.treeData.parkingId,
        beginTime: this.search.beginDate,
        endTime: this.search.endDate,
      })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    echarts: function () {
      this.myChart.series[0].data = [];
      this.myChart.xAxis[0].data = [];
      var _this = this;
      this.$get(chargeOfDay(), {
        parkingId: this.treeData.parkingId,
        beginTime: this.search.beginDate,
        endTime: this.search.endDate,
      }).then((data) => {
        // if(data.status!=200) return;
        for (var i in data) {
          this.myChart.series[0].data.push(data[i].totalMoney);
          this.myChart.xAxis[0].data.push(data[i].datelist);
        }

        // let myChart = this.$echarts.init(document.getElementById('myChart'));
        // myChart.setOption(this.myChart);
      });
    },
    searchList: function () {
      if (this.loading) return;
      var flTime = this.timeCompare(this.search.beginDate, this.search.endDate);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.beginDate) &&
        Boolean(this.search.endDate)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.beginDate) &&
        !Boolean(this.search.endDate)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      if (this.treeData.parkingId) {
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
      // this.echarts();
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
      this.tableList(this.search.pageNumber);
    },
    openRecovery(row) {
      if (!this.treeData.parkingId) {
        this.$message.warning("请先选择车场");
        return;
      }
      const d = dayjs(row.chargeDate);
      const beginTime = d.startOf("month").format("YYYY-MM-DD 00:00:00");
      const endTime = d.endOf("month").format("YYYY-MM-DD 23:59:59");
      this.$router.push({
        path: "/main/record/recoveryRoadArrearsRecord",
        query: {
          parkingId: this.treeData.parkingId,
          beginTime,
          endTime,
        },
      });
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,
  },

  mounted: function () {
    // this.echarts();
  },
  watch: {
    switchValue: function (newVal, oldVal) {
      if (newVal === "chart") {
        this.showChart = true;
        this.showList = false;
        // this.$nextTick(function(){let myChart = this.$echarts.init(document.getElementById('myChart'));
        // myChart.setOption(this.myChart);})
      } else {
        this.showChart = false;
        this.showList = true;
      }
    },
  },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.link-trade-id {
  color: #278cd8;
  cursor: pointer;
}
.link-trade-id:hover {
  text-decoration: underline;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>

 